import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import FormErrorNotification from "../../../form-error-notification";
import {
  getDataReports,
  getDataReportsError
} from "../../../../store/data-report";
import { injectIntl, FormattedMessage } from "react-intl";
import sharedMessages from "../../../../../shared-messages";
import messages from "./data-report-list-messages";

import "./data-report-list.scss";

const DataReportList = ({
  intl: { formatDate, formatMessage },
  dataReports,
  error
}) => {
  if (error) {
    return (
      <div className={"data-report-list"}>
        <FormErrorNotification
          className="data-report-list__error-notification"
          headerMessage={formatMessage(sharedMessages.somethingWentWrong)}
          descriptionMessage={formatMessage(messages.unableToLoadReports)}
          scrollToOnMount={false}
        />
      </div>
    );
  }

  return (
    <div className={"data-report-list"}>
      {dataReports.length > 0 ? (
        <ul className="data-report-list__list">
          {dataReports.map(({ jobId, reportUrl, requestDateTime, status }) => (
            <li key={jobId} className="data-report-list__item">
              {status === "complete" ? (
                <FormattedMessage
                  {...messages.viewPersonalDataReport}
                  values={{
                    date: displayDate(formatDate, requestDateTime),
                    a: displayLink(reportUrl)
                  }}
                />
              ) : (
                <FormattedMessage
                  {...messages.personalDataReportProcessing}
                  values={{
                    date: displayDate(formatDate, requestDateTime)
                  }}
                />
              )}
            </li>
          ))}
        </ul>
      ) : (
        <FormattedMessage {...messages.noCurrentReports} />
      )}
    </div>
  );
};

const displayDate = (formatDate, requestDateTime) => () => (
  <span className="date">
    {formatDate(requestDateTime, {
      month: "2-digit",
      day: "2-digit",
      year: "numeric"
    })}
  </span>
);

const displayLink = reportUrl => msg => (
  <a href={reportUrl} className="hyperlink">
    {msg}
  </a>
);

DataReportList.propTypes = {
  dataReports: PropTypes.arrayOf(
    PropTypes.shape({
      jobId: PropTypes.string.isRequired,
      requestDateTime: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      reportUrl: PropTypes.string
    })
  ).isRequired
};

const mapStateToProps = state => ({
  dataReports: getDataReports(state),
  error: getDataReportsError(state)
});

export { DataReportList };
export default compose(injectIntl, connect(mapStateToProps))(DataReportList);
